import React, { Component } from "react";
import PropTypes from "prop-types";
import OwLabel from "../OwLabel/OwLabel";
import ActivityIndicator from "../ActivityIndicator/ActivityIndicator";
import OwSelectOption from "../OwSelectOption/OwSelectOption";
import OwInputWrapper from "../OwInputWrapper/OwInputWrapper";
import { FormattedNumber } from "react-intl";
import OwButton from "../OwButton/OwButton";
import * as _ from "lodash-es";
import squareLogo from "../../../assets/images/square/square-logo-white.png";
import OwTitle from "../OwTitle/OwTitle";

type Props = {
    userModel: any;
    shipmentGroupModel: any;
    socket: any;
    closeModal: any;
    supplierModel: any;
};

type State = {
    gettingSquareDataActive: boolean;
    squareCustomerCards: any[];
    selectedCustomerCard?: any;
    amount?: any;
    successfulCharge?: boolean;
    square_transaction_id?: string;
    square_order_id?: string;
    square_transaction_date?: string;
    shipmentGroup?: any;
    submitChargeActive: boolean;
    customer?: any;
    squareLocations?: any;
    hasCards?: boolean;
    location?: any;
};

class SquareChargeCustomer extends Component<Props, State> {
    readonly state: State = {
        gettingSquareDataActive: true,
        squareCustomerCards: [],
        selectedCustomerCard: null,
        customer: null,
        hasCards: true,
        shipmentGroup: null,
        submitChargeActive: false,
    };

    constructor(props: any) {
        super(props);

        const square_transaction_id = _.get(this.props.shipmentGroupModel, "square_transaction_id", "");
        const square_order_id = _.get(this.props.shipmentGroupModel, "Orders[0].name", "");
        const square_transaction_date = _.get(this.props.shipmentGroupModel, "square_transaction_date", "");

        let successfulCharge = false;

        if (!_.isNil(square_transaction_id) && !_.isNil(square_order_id)) {
            successfulCharge = true;
        }

        this.state.amount = parseFloat(this.props.shipmentGroupModel.qbo_InvoiceTotal).toFixed(2);
        this.state.square_transaction_id = square_transaction_id;
        this.state.square_order_id = square_order_id;
        this.state.square_transaction_date = square_transaction_date;
    }

    componentDidMount() {
        // get the customer details from squares server.
        if (_.isNil(this.state.square_transaction_id)) {
            this.getSquareCustomer();
        }

        this.props.socket.on("onSquareGetCustomer", this.onSquareGetCustomer);
        this.props.socket.on("onSquareCreateOrderAndCharge", this.onSquareCreateOrderAndCharge);
        //
    }

    componentWillUnmount() {
        this.props.socket.removeListener("onSquareGetCustomer", this.onSquareGetCustomer);
        this.props.socket.removeListener("onSquareCreateOrderAndCharge", this.onSquareCreateOrderAndCharge);
    }

    onSquareGetCustomer = (data: any) => {
        // console.log('onSquareGetCustomer', data);
        this.setState({
            gettingSquareDataActive: false,
            customer: data.customer,
            squareCustomerCards: data.customer.cards,
            squareLocations: data.locations,
            hasCards: _.isNil(data.customer.cards) || data.customer.cards.length === 0 ? false : true,
        });
    };

    getSquareCustomer = () => {
        // console.log(this.props.shipmentGroupModel);

        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.shipmentGroupModel.Supplier.guid,
            vendorGuid: this.props.shipmentGroupModel.Vendor.guid,
            squareCustomerId: _.get(this.props.shipmentGroupModel, "Vendor.Vendor_Integration.square_customer_id", undefined),
        };

        this.props.socket.emit("squareGetCustomer", payload);

        this.setState({
            gettingSquareDataActive: true,
        });
    };

    submit = () => {
        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.shipmentGroupModel.Supplier.guid,
            shipmentGroupGuid: this.props.shipmentGroupModel.guid,
            squareCustomerId: _.get(this.props.shipmentGroupModel, "Vendor.Vendor_Integration.square_customer_id", undefined),
            squareLocationId: this.state.location,
            customerCardId: this.state.selectedCustomerCard,
            totalAmount: this.state.amount,
        };

        this.props.socket.emit("squareCreateOrderAndCharge", payload);

        this.setState({
            submitChargeActive: true,
        });
    };

    onSquareCreateOrderAndCharge = (data: any) => {
        console.log("onSquareCreateOrderAndCharge", data);

        if (!_.isNil(data.shipmentGroup.square_order_id) && !_.isNil(data.shipmentGroup.square_transaction_id)) {
            this.setState({
                successfulCharge: true,
                square_order_id: data.shipmentGroup.square_order_id,
                square_transaction_id: data.shipmentGroup.square_transaction_id,
                square_transaction_date: data.shipmentGroup.square_transaction_date,
                shipmentGroup: data.shipmentGroup,
                submitChargeActive: false,
            });
        }
    };

    cancel = () => {
        this.props.closeModal(this.state.shipmentGroup);
    };

    handleCardChange = (e: any) => {
        console.log("handleCardChange", e.target.value);
        let value = e.target.value;

        if (!value.length) {
            value = null;
        }

        this.setState({
            selectedCustomerCard: value,
        });
    };

    handleChange = (e: any) => {
        const value = e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    render() {
        let isFormComplete = true;

        if (_.isNil(this.state.selectedCustomerCard)) {
            isFormComplete = false;
        }

        if (!this.state.amount.length || this.state.amount <= 0) {
            isFormComplete = false;
        }

        /**
     * Square onGetCustomer cards property
     *
     cards: Array(1)
     0:
     card_brand: "VISA"
     cardholder_name: "Stephen M Bero"
     exp_month: 12
     exp_year: 2023
     id: "ccof:yvpffFukkT74tnmv3GB"
     last_4: "8789"
     */

        return (
            <div className="SquareChargeCustomer d-flex flex-column h-100">
                <div>
                    <img className={"img-fluid"} src={squareLogo} title={"Square"} style={{ height: "3rem" }} />
                </div>

                <div className={this.state.successfulCharge ? "mt-5 d-flex flex-column flex-grow" : "d-none"}>
                    <OwTitle title={"successfully_charged"} tag={"h3"} className={"text-success"} />

                    <div>
                        <div className={"mt-2"}>
                            <OwLabel title={"order_id"} isBold={true} />
                        </div>

                        {this.state.square_order_id}
                    </div>

                    <div>
                        <div className={"mt-5"}>
                            <OwLabel title={"transaction_id"} isBold={true} />
                        </div>

                        {this.state.square_transaction_id}
                    </div>

                    <div>
                        <div className={"mt-5"}>
                            <OwLabel title={"transaction_date"} isBold={true} />
                        </div>

                        {this.state.square_transaction_date}
                    </div>

                    <div className={"row align-items-end flex-grow ms-0"}>
                        <OwButton title={"close"} fn={this.cancel} className={"btn-primary"} />
                    </div>
                </div>

                <div className={this.state.successfulCharge ? "d-none" : ""}>
                    <div className={"mb-2 mt-4"}>
                        <div>
                            <OwLabel
                                title={"vendor"}
                                isBold={true}
                                supplierModel={this.props.supplierModel}
                                isSupplierVendorOverride={true}
                            />
                        </div>
                        {this.props.shipmentGroupModel.Vendor.name}
                    </div>

                    <div className={"mt-4"}>
                        <div>
                            <OwLabel title={"credit_card"} isBold={true} className={"me-3"} />
                            <ActivityIndicator active={this.state.gettingSquareDataActive} />
                        </div>
                        <OwSelectOption
                            options={this.state.squareCustomerCards}
                            valueProp={"id"}
                            titleProp={"card_brand"}
                            titlePropTwo={"last_4"}
                            fn={this.handleCardChange}
                            name={"card"}
                            isDisabled={this.state.gettingSquareDataActive}
                        />

                        <div className={this.state.hasCards ? "d-none" : ""}>
                            <p className={"text-danger"}>
                                <OwLabel title={"no_cards_please_add"} />
                            </p>
                        </div>
                    </div>

                    <div className={"mt-4"}>
                        <div>
                            <OwLabel title={"location"} isBold={true} className={"me-3"} />
                        </div>
                        <OwSelectOption
                            options={this.state.squareLocations}
                            valueProp={"id"}
                            titleProp={"address.address_line_1"}
                            fn={this.handleChange}
                            name={"location"}
                            isDisabled={this.state.gettingSquareDataActive}
                        />

                        <div className={this.state.hasCards ? "d-none" : ""}>
                            <p className={"text-danger"}>
                                <OwLabel title={"no_cards_please_add"} />
                            </p>
                        </div>
                    </div>

                    <div className={"mt-4"}>
                        <div>
                            <hr className={"charcoal-grey-bg"} />

                            <div>
                                <div>
                                    <OwLabel title={"invoice_amount"} isBold={true} className={"me-2"} />
                                </div>
                                <FormattedNumber
                                    value={this.props.shipmentGroupModel.qbo_InvoiceTotal}
                                    style={"currency"}
                                    currency={"USD"}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={"mt-4"}>
                        <div>
                            <OwLabel isBold={true} title={"charge_amount"} />
                        </div>
                        <OwInputWrapper fn={this.handleChange} value={this.state.amount} name={"amount"} type={"number"} showStep={true} />
                    </div>

                    <div className={"mt-4"}>
                        <OwButton
                            disabled={!isFormComplete || this.state.submitChargeActive}
                            active={this.state.submitChargeActive}
                            title={"submit"}
                            fn={this.submit}
                            className={"btn-success me-2"}
                        />

                        <OwButton title={"cancel"} fn={this.cancel} className={"btn-danger"} />
                    </div>
                </div>
            </div>
        );
    }
}

export default SquareChargeCustomer;
